import { executeReCaptcha } from "../../helper/executeReCaptcha";

const ApiService = require("../../services/ApiService");

Vue.component("legend-contact-form", {

    template: `<div class="legend-contact-container" ref="contactContainer">
        <form class="legend-contact-form">
            <slot name="form-fields"></slot>
        </form>
    </div>`,

    props: {
        recipient: {
            type: String,
            default: null
        },
        subject: {
            type: String,
            default: null
        }
    },

    data()
    {
        return {
            fields: []
        };
    },

    created()
    {},

    mounted()
    {
        this.$nextTick(() =>
        {
            this.initializeForm();
        });
    },

    methods:
    {
        initializeForm()
        {
            $(this.$refs.contactContainer).on("submit", (event) =>
            {
                event.preventDefault();
                this.fields = $(event.target).serializeArray();
                this.validate(event);
            });
        },

        validate(event)
        {
            if ($(this.$refs.contactContainer).find("#privacypolicy").length === 0 || $(this.$refs.contactContainer).find("#privacypolicy").is(":checked"))
            {
                executeReCaptcha(event.target).then((recaptchaResponse) =>
                {
                    this.sendMail(recaptchaResponse);
                })
                    .catch(() =>
                    {
                        CeresNotification.error(
                            this.$translate("Ceres::Template.contactReCaptchaFailed")
                        );
                    });
            }
            else
            {
                CeresNotification.error(
                    this.$translate("Ceres::Template.contactAcceptFormPrivacyPolicy", { hyphen: "&shy;" })
                );
            }
        },

        sendMail(recaptchaToken = null)
        {
            const originalClass = $(this.$refs.contactContainer).find("button[type=\"submit\"] > i").attr("class");

            $(this.$refs.contactContainer).find("button[type=\"submit\"] > i").attr("class", "fa fa-circle-o-notch fa-spin");

            const mailObj =
            {
                subject: this.subject,
                userMail: $(this.$refs.contactContainer).find("#user-mail").eq(0).val(),
                recipient: this.recipient,
                fields: this.fields,
                cc: $(this.$refs.contactContainer).find("#cc").eq(0).is(":checked")
            };

            ApiService.post("/rest/legend/customer/contact/mail", { contactData: mailObj, template: "Legend::Widgets.ContactForm.Components.ContactMail", recaptchaToken: recaptchaToken }, { supressNotifications: true })
                .done(response =>
                {
                    this.clearFields();
                    CeresNotification.success(
                        this.$translate("Ceres::Template.contactSendSuccess")
                    );
                    document.dispatchEvent(new CustomEvent("onContactFormSend", { detail: mailObj }));
                })
                .fail(response =>
                {
                    if (response.validation_errors)
                    {
                        let errorMessage = "";

                        for (const value of Object.values(response.validation_errors))
                        {
                            errorMessage += value + "<br>";
                        }
                        CeresNotification.error(errorMessage);
                    }
                    else
                    {
                        response.error.message = response.error.message || this.$translate("Ceres::Template.contactSendFail");
                        CeresNotification.error(response.error);
                    }
                })
                .always(() =>
                {
                    $(this.$refs.contactContainer).find("button[type=\"submit\"] > i").attr("class", originalClass);
                });
        },

        clearFields()
        {
            $(this.$refs.contactContainer).find(".legend-contact-form")[0].reset();
        }
    }
});
